import { create } from '@thoughtspot/logger';
import {
    MetricsService,
    PropertyMap,
    UserAction,
    userActionTypeEnum,
} from '@thoughtspot/metrics';

const Logger = create('spreadsheet-mixpanel-util');

const trackSpreadsheetEvent = (
    action: typeof userActionTypeEnum[keyof typeof userActionTypeEnum],
    data: PropertyMap,
    metricsService: MetricsService,
) => {
    try {
        metricsService.collectEvent(new UserAction(action), data);
    } catch (error) {
        Logger.error(error, `Failed to track ${action} event`);
    }
};

export type SpreadsheetOpenedSource =
    | 'home_nav' // keeping it as per prd for now, will be a follow up task to look into in phase 2
    | 'search_data'
    | 'answer_reopen';

export const trackSpreadsheetOpened = (
    data: { source: SpreadsheetOpenedSource },
    metricsService: MetricsService,
) =>
    trackSpreadsheetEvent(
        userActionTypeEnum.SPREADSHEET_OPENED,
        { source: data.source },
        metricsService,
    );

// Tracks the Query/Spreadsheet toggle click on the answer screen — a UI
// control interaction, distinct from spreadsheet-opened (arrival in
// spreadsheet mode by any means, e.g. redirects or direct URLs).
export const trackSpreadsheetToggleClick = (metricsService: MetricsService) =>
    trackSpreadsheetEvent(
        userActionTypeEnum.SPREADSHEET_TOGGLE_CLICK,
        {},
        metricsService,
    );

export const trackSpreadsheetFormulaCreated = (
    data: { formulaType: string; columnCount: number },
    metricsService: MetricsService,
) =>
    trackSpreadsheetEvent(
        userActionTypeEnum.SPREADSHEET_FORMULA_CREATED,
        {
            formula_type: data.formulaType,
            column_count: data.columnCount,
        },
        metricsService,
    );

export const trackSpreadsheetSaved = (
    data: { columnCount: number; formulaCount: number },
    metricsService: MetricsService,
) =>
    trackSpreadsheetEvent(
        userActionTypeEnum.SPREADSHEET_SAVED,
        {
            column_count: data.columnCount,
            formula_count: data.formulaCount,
        },
        metricsService,
    );

export const trackSpreadsheetFullscreenToggled = (
    data: { isFullscreen: boolean },
    metricsService: MetricsService,
) =>
    trackSpreadsheetEvent(
        userActionTypeEnum.SPREADSHEET_FULLSCREEN_TOGGLED,
        { is_fullscreen: data.isFullscreen },
        metricsService,
    );
